let infoPage = document.body.classList.contains('page_information');

window.addEventListener('DOMContentLoaded', () => {
    if (infoPage) {
        let infoTables = document.querySelectorAll('table');
        infoTables.forEach((infoTable) => {
            infoTable.parentElement.classList.add('table-responsive');
        });
    }
});